/* global axios */
import ApiClient from './ApiClient';

class TalkviaPlanAdjustmentsAPI extends ApiClient {
  constructor() {
    super('talkvia_plan_adjustments', { accountScoped: true });
  }

  scheduleReduction(itemKey, quantity) {
    return axios.post(this.url, { item_key: itemKey, quantity });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new TalkviaPlanAdjustmentsAPI();
